import { observable, action } from "mobx";
import { BranchInfoModel, CmsLinkModel } from "../../../models";
import { BaseSportsHamburgerDataComposition, BaseSportsHamburgerBlockData } from "../../../data";

export class SportsHamburgerBlockData extends BaseSportsHamburgerBlockData {
    branchesCache!: BranchesCache;
    cmsLinks!: CmsLinkModel[];
    @observable sportsData: BranchInfoModel[];
    panels!: any[];
    openBranchHandler: Function;
    adjustPathFunc!: Function;
    navigateToCmsLinkHandler!: Function;
    mapToBranchInfoModelRef: (value: BranchInfoType) => BranchInfoModel;
    mapToCmsLinkModelRef!: (value: any) => CmsLinkModel;
    closeMenuHandler: Function;

    constructor(provider: BaseSportsHamburgerDataComposition, navHandler: any) {
        super(provider, navHandler);

        this.openBranchHandler = navHandler.OpenBranchPanel;
        this.mapToBranchInfoModelRef = this.mapToBranchInfoModel.bind(this);
        this.sportsData = this.branchesCache.BranchesOrdered.map(this.mapToBranchInfoModelRef);
        this.closeMenuHandler = navHandler.CloseLeftNav;

        // Attach events
        this.branchesCache.addListener(this, this.updateSportsData);
    }

    /* istanbul ignore next */
    @action.bound updateSportsData() {
        this.sportsData = this.branchesCache.BranchesOrdered.map(this.mapToBranchInfoModelRef);
    }

    mapToBranchInfoModel(branchInfo) {
        return new BranchInfoModel({
            id: branchInfo.ID,
            name: branchInfo.Name,
            href: this.adjustPathFunc(branchInfo.Code),
            hasLiveEvents: branchInfo.hasLiveEvents,
            totalLiveCount: branchInfo.TotalLiveCount,
            handler: this.openBranchPanel.bind(
                this,
                branchInfo.ID
            )
        });
    }

    openBranchPanel(branchId, event) {
        this.closeMenuHandler();
        this.openBranchHandler(event, branchId, event.target);
    }
}